var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLatitude(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 1C4.13793 1 1 4.13648 1 8C1 11.8635 4.13793 15 8 15C11.8669 15 15 11.8635 15 8C15 4.13648 11.8669 1 8 1ZM12.4655 12.747C11.2972 13.8443 9.72827 14.5172 8 14.5172C6.27655 14.5172 4.70276 13.8443 3.53931 12.747H12.4655ZM14.0248 10.4939C13.7545 11.1437 13.3827 11.7404 12.9289 12.2642H3.07583C2.62203 11.7409 2.2503 11.1437 1.97995 10.4939H14.0248ZM14.5124 8.24138C14.4931 8.8569 14.3821 9.45069 14.2034 10.0112H1.80134C1.61789 9.45069 1.51173 8.8569 1.48759 8.24138H14.5124ZM14.2034 5.98834C14.3821 6.54931 14.4931 7.1431 14.5124 7.75862H1.48759C1.51173 7.1431 1.61789 6.54931 1.80134 5.98834H14.2034ZM12.9289 3.73531C13.3827 4.2591 13.7545 4.85579 14.0248 5.50559H1.97995C2.2503 4.85579 2.62203 4.2591 3.07583 3.73531H12.9289ZM12.4655 3.25255H3.53931C4.70276 2.15524 6.27655 1.48276 8 1.48276C9.72827 1.48276 11.2972 2.15524 12.4655 3.25255Z",
    fill: "#A559D9",
    stroke: "#A559D9",
    strokeWidth: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLatitude);
export default __webpack_public_path__ + "static/media/Latitude.e19a46b8aac3322947a6c0be0084ffc8.svg";
export { ForwardRef as ReactComponent };